import { createSimpleStore } from '@passionware/simple-store';
import type { Locale } from './LocaleService';

const store = createSimpleStore<Locale | null>(null);

/** The language a public page opens in, which its page sets (`usePageDefaultLanguage`). */
export const pageDefaultLanguage = {
  set: (locale: Locale) => store.setNewValue(locale),
  resolve: async (): Promise<Locale> => store.getCurrentValue() ?? 'en'
};
